export class MobileConfig {
    static DEFAULT_EQUIPMENT = 1;
    static WINDOW_WIDTH = 768;
  }
